<script>
  import { onMount, onDestroy, createEventDispatcher } from 'svelte'
  import { get } from 'svelte/store'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import { ga } from '@beyonk/svelte-google-analytics'

  import AnimatedTitle from './components/AnimatedTitle.svelte'
  import AnimatedBlock from './components/AnimatedBlock.svelte'
  import AnimatedLine from './components/AnimatedLine.svelte'
  import Accordion from './components/Accordion.svelte'
  import { transformForm } from './Helpers'
  import { emailStore } from './store'

  const dispatch = createEventDispatcher()
  let buttons,
    self,
    st,
    rateFormLoaded = false,
    rateFormNeedsLoading = true,
    ratingComplete = false,
    fadePrevTL
  const formId = 3753

  onMount(() => {
    fadePrevTL = gsap.timeline({ paused: true })
    const previousSection = self.previousElementSibling
    fadePrevTL.to(previousSection, { opacity: 0, duration: 0.5, ease: 'none' }, 0)

    const tl = gsap.timeline()
    tl.from(
      buttons.querySelectorAll('.btn-wrap'),
      {
        opacity: 0,
        y: 30,
        ease: 'power2.out',
        stagger: 0.1,
        duration: 1,
      },
      0
    )
    st = ScrollTrigger.create({
      trigger: buttons,
      animation: tl,
      start: 'top 70%',
      toggleActions: 'play play play pause',
      onEnter: onEnterAnim,
      onLeaveBack: () => fadePrevTL.reverse(),
    })
  })

  function onEnterAnim() {
    fadePrevTL.play()
    loadRateForm()
  }

  onDestroy(() => {
    fadePrevTL?.pause().kill()
    st?.kill()
  })

  function clickContact() {
    top.location.href =
      'https://www.verizonmedia.com/advertising/solutions/advanced-tv?utm_source=event&utm_medium=website&utm_campaign=atv1h21&utm_id=7010e000000xaEdAAI'
  }

  function clickRestart() {
    dispatch('path', { name: 'intro' })
  }

  function clickRate() {
    loadRateForm()
  }

  function loadRateForm() {
    if (!rateFormNeedsLoading) return
    rateFormNeedsLoading = false
    if (typeof window.MktoForms2 === 'undefined') return

    MktoForms2.loadForm('//pages.verizonmedia.com', '118-OEW-181', formId, (form) => {
      rateFormLoaded = true
      form.onSuccess((e) => {
        ratingComplete = true
        ga.addEvent('rating_submit_complete', {
          formId,
        })
        return false
      })
      form.onSubmit((e) => {
        try {
          ga.addEvent('rating_submit_begin', {
            formId,
          })
        } catch (e2) {
          console.log(e2)
        }
      })
      transformForm(form)
      const savedEmail = get(emailStore)
      const formEl = form.getFormElem()[0]
      if (formEl) {
        if (savedEmail) {
          const inputEl = formEl.querySelector('input[type=email]')
          inputEl.value = savedEmail
          inputEl.closest('.mktoFormRow').classList.add('hidden')
        }
        if (formEl.querySelector('.mktoFormRow').innerHTML.indexOf('mktoHtmlText') > -1) {
          formEl.querySelector('.mktoFormRow').remove()
        }
      }
    })
  }
</script>

<section class="complete" bind:this={self}>
  <div class="rgrid-md-12-col">
    <div class="col">
      <AnimatedLine color="red" size={5} />
      <AnimatedTitle class="medium">Supercharge your Advanced TV strategy with Verizon Media.</AnimatedTitle>
      <AnimatedBlock delay={0.3}><h2 class="subtitle">Contact us to learn more today.</h2></AnimatedBlock>
      <div class="buttons" bind:this={buttons}>
        <div class="btn-wrap">
          <a
            class="contact-btn pill-btn"
            href="https://www.verizonmedia.com/advertising/solutions/advanced-tv?utm_source=event&utm_medium=website&utm_campaign=atv1h21&utm_id=7010e000000xaEdAAI"
            >Learn more</a
          >
        </div>
        <div class="btn-wrap">
          <button type="button" class="custom text-btn restart-btn" on:click|preventDefault={clickRestart}
            >Start over</button
          >
        </div>
      </div>
      {#if ratingComplete}
        <AnimatedTitle size={2}>Thank you for the feedback.</AnimatedTitle>
      {:else}
        <Accordion
          id="rate_experience"
          title="Rate your experience"
          on:toggle={clickRate}
          triggerStart="top bottom-=100"
          fireChangeEvent={false}
        >
          <form id="mktoForm_{formId}"></form>
        </Accordion>
      {/if}
    </div>
  </div>
</section>

<style>
  section {
    margin-top: 5rem;
    min-height: 550px;
  }
  section :global(.hline) {
    margin-bottom: 0.625rem;
  }
  .contact-btn {
    margin-top: 2.25rem;
  }
  .restart-btn {
    margin: 1.5rem 0 3.5rem;
  }
  section :global(.subtitle) {
    font-weight: 500;
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    .col {
      grid-column: 4 / span 8;
    }
    section {
      padding-top: 10rem;
      margin-top: 0;
      min-height: 80vh;
    }
    .restart-btn {
      margin-bottom: 4rem;
    }
  }
  form :global(.mktoFormRow:nth-of-type(2)) {
    margin-bottom: -20px;
  }
</style>
